type AdminOrganizationOrdersProps = {
  organizationId: string
}
export const AdminOrganizationOrders = (
  props: AdminOrganizationOrdersProps
): JSX.Element => {
  return <div>TAB ORDERS</div>
}
